(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article__slideshow"] && !Shopify.designMode) return;
  try {
     
  function FeaturedCollection (container) {
    let collectionProductSliderConfig = {
      arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
      cellAlign: "center",
      contain: true,
      groupCells: "100%",
      imagesLoaded: true,
      pageDots: false,
      resize: true,
      draggable: true,
      prevNextButtons: true,
      adaptiveHeight: false,
      wrapAround: false,
      lazyLoad: true
    }
    this.init(container, collectionProductSliderConfig);
  }
  
  FeaturedCollection.prototype = {
    init: function(container, config){     
      this.slideContainer = document.querySelectorAll('.featured-collection__loop--slider-true');      
      this.sliderConfig = config;
      this.slideContainer.forEach(function(e){
        this.buildSlider(e, this.sliderConfig);   
      }.bind(this));
      this.initEvents();
    },
    buildSlider: function(container, config){
      return new Flickity(container, config);
    },
    resizeSlider: function(slider){
      if(slider){
        slider.resize();
      }
    },
    initEvents: function(){
      events.on('resize', '*', function(event){
        this.resizeSlider(this.collectionProductSlider)
      }.bind(this))
    },
  }
  
  const featuredCollection = {
    runFeaturedCollection: function(container){
      let slider = new FeaturedCollection(container)
    }
  }

  window.theme = window.theme || {};
  window.theme.scripts = window.theme.scripts || {};
  window.theme.scripts.featured_collection = window.theme.scripts.featured_collection || {};
  window.theme.scripts.featured_collection.init = featuredCollection.runFeaturedCollection;

  window.theme.scripts.featured_collection.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b__hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.bhBound === '1') return;
    root.dataset.bhBound = '1';
    var cta = root.querySelector('[data-b2b-hero-cta]');
    if (!cta) return;
    cta.addEventListener('click', function (e) {
      var href = cta.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1) {
        var target;
        try { target = document.querySelector(href); } catch (_) { target = null; }
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-b2b-hero]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b__hot-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.bhBound === '1') return;
    root.dataset.bhBound = '1';

    var grid  = root.querySelector('[data-b2b-hot-grid]');
    var tabs  = root.querySelector('[data-b2b-hot-tabs]');
    var toast = root.querySelector('[data-b2b-hot-toast]');

    function showToast(msg, kind) {
      if (!toast) return;
      toast.hidden = false;
      toast.className = 'b2b-hot__toast' + (kind ? ' b2b-hot__toast--' + kind : '');
      toast.textContent = msg;
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.hidden = true; }, 2800);
    }

    // Qty steppers
    root.querySelectorAll('.b2b-hot__qty').forEach(function (qty) {
      var input = qty.querySelector('[data-qty]');
      if (!input) return;
      qty.querySelectorAll('button[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.step, 10) || 0;
          var min = parseInt(input.min, 10) || 1;
          var max = parseInt(input.max, 10) || 999;
          var v = parseInt(input.value, 10) || min;
          input.value = Math.min(max, Math.max(min, v + step));
        });
      });
    });

    // Favourite (visual only)
    root.querySelectorAll('[data-b2b-hot-fav]').forEach(function (btn) {
      btn.addEventListener('click', function () { btn.classList.toggle('is-active'); });
    });

    // Collection tabs — show only the cards belonging to the active tab.
    if (tabs) {
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-tab]');
        if (!btn) return;
        tabs.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        var tab = btn.dataset.tab;
        root.querySelectorAll('[data-b2b-hot-card]').forEach(function (card) {
          card.classList.toggle('is-hidden', card.dataset.tab !== tab);
        });
      });
    }

    // Add to order
    root.querySelectorAll('[data-b2b-hot-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var id = parseInt(btn.dataset.variantId, 10);
        if (!id) { showToast('Variant unavailable.', 'error'); return; }
        var card = btn.closest('[data-b2b-hot-card]');
        var qtyEl = card && card.querySelector('[data-qty]');
        var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
        var title = btn.dataset.productTitle || 'item';
        var original = btn.innerHTML;

        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) {
              btn.disabled = false;
              showToast((res.body && res.body.description) || 'Could not add to order.', 'error');
              return;
            }
            btn.classList.add('is-added');
            btn.innerHTML = '✓ Added';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.innerHTML = original;
              btn.disabled = false;
            }, 1100);
            showToast('Added ' + qty + ' × ' + title + ' to order.', 'success');
            var detail = { item: res.body, source: 'b2b-hot' };
            ['cart:refresh','cart:updated','cart:added','cart-updated'].forEach(function (n) {
              document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: detail }));
            });
          })
          .catch(function () {
            btn.disabled = false;
            showToast('Network error. Try again.', 'error');
          });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-b2b-hot]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog__article-slideshow"] && !Shopify.designMode) return;
  try {
     
function getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
  const earthRadius = 3958.8; // miles
  const radianLat1 = degreesToRadians(lat1);
  const radianLat2 = degreesToRadians(lat2);
  const deltaLat = degreesToRadians(lat2 - lat1);
  const deltaLng = degreesToRadians(lng2 - lng1);
  const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(radianLat1) * Math.cos(radianLat2) *
    Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;
  return distance;
}

function degreesToRadians(degrees) {
  return degrees * (Math.PI / 180);
}

  window.onload = function() {
    var winLoc = window.loc;
    var tag = "fishing-in-"+window.ipRegionAbbrev;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/blogs/where-to-fish/tagged/" + tag + "?view=ajax", true);
    xhr.responseType = "json";
    xhr.onload = function() {
      if (xhr.status === 200) {
        var articles = xhr.response.articles;
      
        var limit = window.articleLimit;
        var articleHTML = "";

        // Calculate distances for all articles
        articles.forEach(function (article) {
          article.distance = getDistanceBetweenPoints(winLoc[0], winLoc[1], article.tags_loc[0], article.tags_loc[1]).toFixed(2);
        });

        // Sort articles by distance
        articles.sort(function (a, b) {
          return parseFloat(a.distance) - parseFloat(b.distance);
        });

        for (var i = 0; i < limit; i++) {
          var article = articles[i];
          var dist = article.distance;
          articleHTML += '<div class="blog__card-wrapper featured-collection__product featured-collection__product--'+articlesToShow+' featured-collection__product--slider featured-collection__1--slider-true--image-">';
          articleHTML += '<div class="blog-card card-background card-shadow">';          
          articleHTML += '<div class="product-loop-element">';
          articleHTML += "<div class='blog-copy'>";
          articleHTML += '<p class="blog__article-label p--small p--uppercase p-link--no-accent p--extra-small p--bold pb-8">'+window.ipRegion+'</p>';
          articleHTML += "<div class='blog__article-header'>"
          articleHTML += "<a href='/blogs/where-to-fish/"+article.handle+"'>";
          articleHTML += "<h3 class='h4 blog__article-title blog__article-title--card'>" + article.title + "</a></h3>";
          articleHTML += "</a>";
          articleHTML += "</div>";
          articleHTML += '<p class="p--small text--no-margin">'+dist+' miles from your location</p>';
          articleHTML += "<a href='/blogs/where-to-fish/"+article.handle+"'>";
          articleHTML += '<span class="btn">LEARN MORE</span>';
          articleHTML += "</a>";
          articleHTML += "</div></div></div></div></div>";      
        }
        document.getElementById("articles").innerHTML = articleHTML;
        document.getElementById("articles").classList.add('featured-collection__loop--slider-true')
        window.theme.scripts.featured_collection.init(document)
        //document.body.innerHTML = document.body.innerHTML.replace("[PLACE]", window.ipCity);
  
          //document.body.innerHTML = document.body.innerHTML.replace("TOP WATERS NEAR", "TOP WATERS NEAR " + window.ipCity +","+ window.ipRegion + "");
          document.getElementById("dynamic-location").innerText = "TOP WATERS NEAR " + window.ipCity +","+ window.ipRegion + "";
    
     }
    };
    xhr.send();
  };
   function FeaturedCollection (container) {
    let collectionProductSliderConfig = {
      arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
      cellAlign: "center",
      contain: true,
      groupCells: "100%",
      imagesLoaded: true,
      pageDots: false,
      resize: true,
      draggable: true,
      prevNextButtons: true,
      adaptiveHeight: false,
      wrapAround: false,
      lazyLoad: true
    }
    this.init(container, collectionProductSliderConfig);
  }
  
  FeaturedCollection.prototype = {
    init: function(container, config){     
      this.slideContainer = document.querySelectorAll('.featured-collection__loop--slider-true');      
      this.sliderConfig = config;
      this.slideContainer.forEach(function(e){
        this.buildSlider(e, this.sliderConfig);   
      }.bind(this));
      this.initEvents();
    },
    buildSlider: function(container, config){
      return new Flickity(container, config);
    },
    resizeSlider: function(slider){
      if(slider){
        slider.resize();
      }
    },
    initEvents: function(){
      events.on('resize', '*', function(event){
        this.resizeSlider(this.collectionProductSlider)
      }.bind(this))
    },
  }
  
  const featuredCollection = {
    runFeaturedCollection: function(container){
      let slider = new FeaturedCollection(container)
    }
  }

  window.theme = window.theme || {};
  window.theme.scripts = window.theme.scripts || {};
  window.theme.scripts.featured_collection = window.theme.scripts.featured_collection || {};
  window.theme.scripts.featured_collection.init = featuredCollection.runFeaturedCollection;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*!
   * eventslibjs v1.2.0
   * A tiny event delegation helper library.
   * (c) 2019 Chris Ferdinandi
   * MIT License
   * http://github.com/cferdinandi/events
   */
  
   (function (root, factory) {
    if ( typeof define === 'function' && define.amd ) {
      define([], (function () {
        return factory(root);
      }));
    } else if ( typeof exports === 'object' ) {
      module.exports = factory(root);
    } else {
      root.events = factory(root);
    }
  })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, (function (window) {
  
    'use strict';
  
    //
    // Variables
    //
  
    var publicAPIs = {};
    var activeEvents = {};
  
  
    //
    // Methods
    //
  
    /**
     * Get the index for the listener
     * @param  {Array}   arr      The listeners for an event
     * @param  {Array}   listener The listener details
     * @return {Integer}          The index of the listener
     */
    var getIndex = function (arr, selector, callback) {
      for (var i = 0; i < arr.length; i++) {
        if (
          arr[i].selector === selector &&
          arr[i].callback.toString() === callback.toString()
        ) return i;
      }
      return -1;
    };
  
    /**
     * Check if the listener callback should run or not
     * @param  {Node}         target   The event.target
     * @param  {String|Node}  selector The selector to check the target against
     * @return {Boolean}               If true, run listener
     */
    var doRun = function (target, selector) {
      if ([
        '*',
        'window',
        'document',
        'document.documentElement',
        window,
        document,
        document.documentElement
      ].indexOf(selector) > -1) return true;
      if (typeof selector !== 'string' && selector.contains) {
        return selector === target || selector.contains(target);
      }
      return target.closest(selector);
    };
  
    /**
     * Handle listeners after event fires
     * @param {Event} event The event
     */
    var eventHandler = function (event) {
      if (!activeEvents[event.type]) return;
      activeEvents[event.type].forEach((function (listener) {
        if (!doRun(event.target, listener.selector)) return;
        listener.callback(event);
      }));
    };
  
    /**
     * Add an event
     * @param  {String}   types    The event type or types (comma separated)
     * @param  {String}   selector The selector to run the event on
     * @param  {Function} callback The function to run when the event fires
     */
    publicAPIs.on = function (types, selector, callback) {
  
      // Make sure there's a selector and callback
      if (!selector || !callback) return;
  
      // Loop through each event type
      types.split(',').forEach((function (type) {
  
        // Remove whitespace
        type = type.trim();
  
        // If no event of this type yet, setup
        if (!activeEvents[type]) {
          activeEvents[type] = [];
          window.addEventListener(type, eventHandler, true);
        }
  
        // Push to active events
        activeEvents[type].push({
          selector: selector,
          callback: callback
        });
  
      }));
  
    };
  
    /**
     * Remove an event
     * @param  {String}   types    The event type or types (comma separated)
     * @param  {String}   selector The selector to remove the event from
     * @param  {Function} callback The function to remove
     */
    publicAPIs.off = function (types, selector, callback) {
  
      // Loop through each event type
      types.split(',').forEach((function (type) {
  
        // Remove whitespace
        type = type.trim();
  
        // if event type doesn't exist, bail
        if (!activeEvents[type]) return;
  
        // If it's the last event of it's type, remove entirely
        if (activeEvents[type].length < 2 || !selector) {
          delete activeEvents[type];
          window.removeEventListener(type, eventHandler, true);
          return;
        }
  
        // Otherwise, remove event
        var index = getIndex(activeEvents[type], selector, callback);
        if (index < 0) return;
        activeEvents[type].splice(index, 1);
  
      }));
  
    };
  
    /**
     * Add an event, and automatically remove it after it's first run
     * @param  {String}   types    The event type or types (comma separated)
     * @param  {String}   selector The selector to run the event on
     * @param  {Function} callback The function to run when the event fires
     */
    publicAPIs.once = function (types, selector, callback) {
      publicAPIs.on(types, selector, (function temp (event) {
        callback(event);
        publicAPIs.off(types, selector, temp);
      }));
    };
  
    /**
     * Get an immutable copy of all active event listeners
     * @return {Object} Active event listeners
     */
    publicAPIs.get = function () {
      var obj = {};
      for (var type in activeEvents) {
        if (activeEvents.hasOwnProperty(type)) {
          obj[type] = activeEvents[type];
        }
      }
      return obj;
    };
  
  
    //
    // Return public APIs
    //
  
    return publicAPIs;
  
  }));
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-featured-collection"] && !Shopify.designMode) return;
  try {
    
function FeaturedCollection (container) {
  let collectionProductSliderConfig = {
    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
    cellAlign: "center",
    contain: true,
    groupCells: "100%",
    imagesLoaded: true,
    pageDots: false,
    resize: true,
    draggable: true,
    prevNextButtons: true,
    adaptiveHeight: false,
    wrapAround: false,
    lazyLoad: true
  }

  this.init(container, collectionProductSliderConfig);
}

FeaturedCollection.prototype = {
  init: function(container, config){
    this.slideContainer = container.querySelector('.featured-collection__loop--slider-true');
    this.sliderConfig = config;
    this.collectionProductSlider = this.buildSlider(this.slideContainer, this.sliderConfig);
    this.initEvents();
  },
  buildSlider: function(container, config){
    return new Flickity(container, config);
  },
  resizeSlider: function(slider){
    slider.viewport.style.height = "";
    if(slider){
      slider.resize();
    }
  },
  initEvents: function(){
    events.on('resize', '*', function(event){
      this.resizeSlider(this.collectionProductSlider)
    }.bind(this))
  },
}

const featuredCollection = {
  runFeaturedCollection: function(container){
    let slider = new FeaturedCollection(container)
  }
}

window.theme = window.theme || {};
window.theme.scripts = window.theme.scripts || {};
window.theme.scripts.featured_collection = window.theme.scripts.featured_collection || {};
window.theme.scripts.featured_collection.init = featuredCollection.runFeaturedCollection;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gallery"] && !Shopify.designMode) return;
  try {
    
  theme.Site = theme.Site || {};

  function GallerySection (container){
    this.galleryContainer = container.querySelector(".gallery");
    this.galleryBlocks = this.galleryContainer.querySelectorAll(".grid-item");
    this.heightElement = this.galleryContainer.querySelector(".grid__height");
    this.margin = this.galleryContainer.querySelector(".grid__gutter");

    this.settings = {
      itemSelector: ".grid-item", 
      columnWidth: ".grid__size", 
      gutter: ".grid__gutter",
      horizontalOrder: false,
      percentPosition: true
    }
    
    this.videos = container.querySelectorAll('.video-player');

    if(this.videos.length > 0){
      theme.Site._initVideo()
    }
    this.init();
  }

  GallerySection.prototype = {
    init: function(){
      this.msnry = new Masonry(this.galleryContainer, this.settings);
      this._setBlockHeight(this.galleryBlocks);
      this.msnry.layout();
      this._initEvents();
    },
    _initEvents: function(){
      events.on('resize', '*', function(){
        this._resize();
      }.bind(this))
    },
    _resize: function(){
      this._setBlockHeight(this.galleryBlocks);
    },
    _setBlockHeight: function(blocks) {
      var gridHeight = this.heightElement.offsetHeight;
      var heightModifier = 30;
      var gridMargin = this.margin.offsetHeight;
      var blockHeights = [];


      if (window.innerWidth >= 769) {

        blocks.forEach(function(block){
          var blockDetails = {};
          blockDetails.block = block;
          blockDetails.height = block.offsetHeight;
          blockDetails.naturalHeight = block.querySelector('.gallery__text').offsetHeight;
          let blockCanExpand = false;
          let blockHeightModifier = 1;
          if(block.hasAttribute('data-gallery-expand')){
            blockCanExpand = true;
          }
          if(block.hasAttribute('data-desktop-height-mod')){
            blockHeightModifier = parseFloat(block.getAttribute('data-desktop-height-mod'));
          }

          if (block.classList.contains('desktop-small-square')){
            var newHeight = gridHeight; 
          } else if (block.classList.contains('desktop-tall-rectangle')){
            var newHeight = gridHeight * 2 + gridMargin;
          } else if (block.classList.contains('desktop-wide-rectangle') ){
            var newHeight = gridHeight;
          } else if (block.classList.contains('desktop-large-square')){
            var newHeight = gridHeight * 2 + gridMargin;
          } 

          if(blockCanExpand && blockDetails.naturalHeight > newHeight){
            blockDetails.newHeight = blockDetails.naturalHeight * blockHeightModifier;
          } else {
            blockDetails.newHeight = newHeight * blockHeightModifier;
          }
          blockHeights.push(blockDetails);

        })
      } else {
        blocks.forEach(function(block){
          var blockDetails = {};
          blockDetails.block = block;
          blockDetails.height = block.offsetHeight;
          blockDetails.naturalHeight = block.querySelector('.gallery__text').offsetHeight;
          let blockCanExpand = false;
          let blockHeightModifier = 1;
          if(block.hasAttribute('data-gallery-expand')){
            blockCanExpand = true;
          }

          if(block.hasAttribute('data-mobile-height-mod')){
            blockHeightModifier = parseFloat(block.getAttribute('data-mobile-height-mod'));
          }

          if (block.classList.contains('grid-item--mobile-small-square')){
            var newHeight = gridHeight; 
          } else if (block.classList.contains('grid-item--mobile-tall-rectangle')){
            var newHeight = gridHeight * 2 + gridMargin;
          }else if (block.classList.contains('grid-item--mobile-wide-rectangle') ){
            var newHeight = gridHeight;
          } else if (block.classList.contains('grid-item--mobile-large-square')){
            var newHeight = gridHeight * 2 + gridMargin;
          }
          if(blockCanExpand && blockDetails.naturalHeight > newHeight){
            blockDetails.newHeight = blockDetails.naturalHeight * blockHeightModifier;
          } else {
            blockDetails.newHeight = newHeight * blockHeightModifier;
          }
          blockHeights.push(blockDetails);
        })
      }
      blockHeights.forEach(function(element){
        element.block.style.paddingTop = '0px';
        element.block.style.paddingTop = element.newHeight + "px";
      })     
    }
  }
  const galleryActions = {
    runGallery: function(container){
      let gallery = new GallerySection(container)
    }
  }
  
  window.theme = window.theme || {};
  window.theme.scripts = window.theme.scripts || {};
  window.theme.scripts.gallery = window.theme.scripts.gallery || {};
  window.theme.scripts.gallery.init = galleryActions.runGallery;
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-logo-list"] && !Shopify.designMode) return;
  try {
    


function LogoList (container) {
  this.logolistConfig = {
    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
    cellAlign: "left",
    lazyLoad: false,
    freeScroll: false,
    groupCells: "100%",
    pageDots: false,
    contain: true 
  },

  this.sectionContainer = container;
  this.slideContainer = this.sectionContainer.querySelector('.logo-list');
  this.sliderEnabled = this.slideContainer.getAttribute('data-slider');

  this.init();
};

LogoList.prototype = {
  init: function(){
    this._initEvents();
    if(this.sliderEnabled === 'true'){
      this.buildLogoSlider(this.slideContainer, this.logolistConfig);
    }
  },
  _initEvents: function(){

  },
  buildLogoSlider: function(container, config){
    return new Flickity(container, config);
  },
  _resize: function(){

  },
};

const logolistActions = {
  runLogolist: function(container){
    let logolist = new LogoList(container)
  }
}

window.theme = window.theme || {};
window.theme.scripts = window.theme.scripts || {};
window.theme.scripts.logolist = window.theme.scripts.logolist || {};
window.theme.scripts.logolist.init = logolistActions.runLogolist;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-platinum-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Hide ReCharge's injected subscription widget on this PDP. Our custom plan
  // selector replaces it, but ReCharge injects its own widget (a Shadow-DOM host
  // with outer container .rc-content-wrap, or the legacy #rc_widget) via a
  // configurable injectionParent that can land OUTSIDE this section — so scoped
  // CSS can't reach it, and its internals are in shadow DOM (only the host is
  // hidable). This section's script only loads on the Platinum PDP, so a
  // document-wide sweep here is safe and leaves ReCharge working on every other
  // product (Gold monthly pass, etc.).
  var RC_WIDGET_SELECTOR = [
    'subscription-options',
    '.rc-content-wrap',
    '.rc_widget',
    '[id^="rc_widget"]',
    '[class*="rc-widget"]',
    'recharge-subscription-widget',
    'recharge-widget'
  ].join(',');
  function hideRechargeWidgets() {
    var nodes = document.querySelectorAll(RC_WIDGET_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.setProperty('display', 'none', 'important');
    }
  }
  var rcObserver;
  function watchRechargeWidgets() {
    hideRechargeWidgets();
    if (rcObserver || !window.MutationObserver) return;
    rcObserver = new MutationObserver(hideRechargeWidgets);
    rcObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initRoot(root) {
    if (!root || root.dataset.ppBound === '1') return;
    root.dataset.ppBound = '1';

    var variantsScript = root.querySelector('[data-pp-variants]');
    var configScript   = root.querySelector('[data-pp-config]');
    if (!variantsScript || !configScript) return;

    var variants = JSON.parse(variantsScript.textContent || '[]');
    var config   = JSON.parse(configScript.textContent || '{}');

    var speciesEls    = root.querySelectorAll('[data-pp-species]');
    var planEls       = root.querySelectorAll('[data-pp-term]');
    var modeEls       = root.querySelectorAll('[data-pp-mode]');
    var variantInput  = root.querySelector('[data-pp-variant-id]');
    var planInput     = root.querySelector('[data-pp-selling-plan]');
    var ctaPriceEl    = root.querySelector('[data-pp-cta-price]');
    var ctaBtn        = root.querySelector('[data-pp-cta]');
    var subscribePriceEl = root.querySelector('[data-pp-subscribe-price]');
    var onetimePriceEl   = root.querySelector('[data-pp-onetime-price]');

    var firstSpecies = (root.querySelector('[data-pp-species].is-selected') || speciesEls[0] || {}).dataset && (root.querySelector('[data-pp-species].is-selected') || speciesEls[0]).dataset.ppSpecies;
    var firstTerm    = (root.querySelector('[data-pp-term].is-selected')    || planEls[0]    || {}).dataset && (root.querySelector('[data-pp-term].is-selected')    || planEls[0]).dataset.ppTerm;

    var ONETIME = config.onetimeTerm || '';

    var initialSpecies = firstSpecies || (variants[0] && variants[0].option1) || '';
    // planEls are subscription terms only (one-time is excluded from the stack).
    var initialTerm    = firstTerm || '';

    var state = {
      species: initialSpecies,
      term:    initialTerm,
      mode:    (ONETIME && config.defaultTerm === ONETIME) ? 'onetime' : 'subscribe'
    };

    function variantFor(species, term) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === species && variants[i].option2 === term) return variants[i];
      }
      return null;
    }
    function subscribeVariant() { return variantFor(state.species, state.term); }
    function onetimeVariant()   { return ONETIME ? variantFor(state.species, ONETIME) : null; }

    function fmtMoney(cents) {
      if (cents == null || isNaN(cents)) return '—';
      return '$' + (cents / 100).toFixed(2);
    }

    function pct(retailCents, priceCents) {
      if (!retailCents || !priceCents || retailCents <= 0) return null;
      var p = Math.round((1 - priceCents / retailCents) * 100);
      return p > 0 ? p : null;
    }

    function render() {
      var subVar    = subscribeVariant();
      var oneVar    = onetimeVariant();
      var activeVar = state.mode === 'onetime' ? oneVar : subVar;

      speciesEls.forEach(function (el) {
        el.classList.toggle('is-selected', el.dataset.ppSpecies === state.species);
      });

      // Plan rows are subscription terms; highlighted only in subscribe mode, so
      // choosing One Time deselects every term row.
      planEls.forEach(function (el) {
        el.classList.toggle('is-selected', state.mode === 'subscribe' && el.dataset.ppTerm === state.term);
        var priceEl = el.querySelector('[data-pp-plan-price]');
        var saveEl  = el.querySelector('[data-pp-plan-save]');
        if (priceEl || saveEl) {
          var pv = variantFor(state.species, el.dataset.ppTerm);
          if (pv) {
            var subPrice = pv.sellingPlanPrice != null ? pv.sellingPlanPrice : pv.price;
            if (priceEl) priceEl.textContent = fmtMoney(subPrice) + '/box';
            if (saveEl) {
              var p = pct(config.retailCents, subPrice);
              saveEl.textContent = p ? 'Save ' + p + '%' : '';
            }
          }
        }
      });

      // Subscribe & Save and One Time are mutually exclusive — driven entirely by state.mode.
      modeEls.forEach(function (el) {
        el.classList.toggle('is-selected', el.dataset.ppMode === state.mode);
      });

      var subCents = subVar ? (subVar.sellingPlanPrice != null ? subVar.sellingPlanPrice : subVar.price) : null;
      var oneCents = oneVar ? oneVar.price : null;
      if (subscribePriceEl) subscribePriceEl.textContent = fmtMoney(subCents);
      if (onetimePriceEl)   onetimePriceEl.textContent   = fmtMoney(oneCents);

      if (!activeVar) {
        if (ctaBtn) ctaBtn.disabled = true;
        if (variantInput) variantInput.value = '';
        if (planInput) planInput.value = '';
        if (ctaPriceEl) ctaPriceEl.textContent = '—';
        return;
      }

      var liveCents, planVal;
      if (state.mode === 'onetime') {
        // Dedicated one-time variant: add it as a plain single purchase with NO selling plan.
        // Forcing a plan here 422s (the plan isn't allocated to this variant), and using the
        // variant's own first allocation could be a subscription plan and silently subscribe.
        liveCents = activeVar.price;
        planVal   = '';
      } else {
        liveCents = activeVar.sellingPlanPrice != null ? activeVar.sellingPlanPrice : activeVar.price;
        planVal   = activeVar.sellingPlanId != null ? activeVar.sellingPlanId : '';
      }

      if (ctaBtn) ctaBtn.disabled = !activeVar.available;
      if (variantInput) variantInput.value = activeVar.id;
      if (planInput) {
        planInput.value = planVal;
        planInput.disabled = !planVal;   // omit an empty selling_plan from the POST entirely
      }
      if (ctaPriceEl) ctaPriceEl.textContent = fmtMoney(liveCents);
    }

    speciesEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        state.species = el.dataset.ppSpecies;
        render();
      });
    });
    planEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        state.term = el.dataset.ppTerm;
        state.mode = 'subscribe';
        render();
      });
    });
    modeEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-pp-cta]')) return;
        state.mode = el.dataset.ppMode;
        if (state.mode === 'subscribe' && !state.term && planEls[0]) state.term = planEls[0].dataset.ppTerm;
        render();
      });
    });

    var mainImage = root.querySelector('[data-pp-main-image]');
    var thumbs    = root.querySelectorAll('[data-pp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var url = thumb.getAttribute('data-image-url');
        var alt = thumb.getAttribute('data-image-alt');
        if (mainImage && url) {
          mainImage.setAttribute('src', url);
          if (alt) mainImage.setAttribute('alt', alt);
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    render();
  }

  function initAll(scope) {
    watchRechargeWidgets();
    (scope || document).querySelectorAll('[data-pp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main__quick-order-by-sku"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.qoBound === '1') return;
    root.dataset.qoBound = '1';

    var form        = root.querySelector('[data-qo-form]');
    var skuInput    = root.querySelector('[data-qo-sku]');
    var qtyInput    = root.querySelector('[data-qo-qty]');
    var submitBtn   = root.querySelector('[data-qo-submit]');
    var submitLabel = root.querySelector('[data-qo-submit-label]');
    var spinner     = root.querySelector('.qo-sku__spinner');
    var toast       = root.querySelector('[data-qo-toast]');
    var mapEl       = root.querySelector('[data-qo-map]');
    var ac          = root.querySelector('[data-qo-autocomplete]');
    var skuMap      = {};
    try { skuMap = JSON.parse((mapEl && mapEl.textContent) || '{}'); } catch (e) {}
    var skuList = Object.keys(skuMap).map(function (k) {
      var v = skuMap[k];
      return {
        sku: k,
        title: v.title || '',
        variant: (v.variant && v.variant !== 'Default Title') ? v.variant : '',
        available: v.available !== false,
        id: v.id,
        price: v.price || '',
        msrp: v.msrp || '',
        inventory: (typeof v.inventory === 'number') ? v.inventory : null
      };
    });
    // Build product → SKUs grouping for title-based search.
    var productGroups = (function () {
      var by = {};
      var order = [];
      skuList.forEach(function (e) {
        var key = e.title || e.sku;
        if (!by[key]) { by[key] = { title: key, skus: [] }; order.push(key); }
        by[key].skus.push(e);
      });
      return order.map(function (k) { return by[k]; });
    })();
    var acIndex = -1;
    var acItems = [];

    function showToast(msg, kind) {
      toast.hidden = false;
      toast.className = 'qo-sku__toast' + (kind ? ' qo-sku__toast--' + kind : '');
      toast.textContent = msg;
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.hidden = true; }, 3200);
    }
    function setBusy(busy) {
      submitBtn.disabled = busy;
      spinner.hidden = !busy;
      submitLabel.style.opacity = busy ? '.6' : '';
    }
    function clampQty(n) {
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 999;
      return Math.min(max, Math.max(min, n));
    }

    root.querySelectorAll('[data-qo-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.qoQtyStep, 10) || 0;
        qtyInput.value = clampQty((parseInt(qtyInput.value, 10) || 1) + step);
      });
    });

    function escHTML(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }

    // Score a product group against the query. Returns 0 if no match;
    // higher = better. SKU-prefix beats title-prefix beats SKU-substring
    // beats title-substring. The same group is shown intact (all its SKUs)
    // even if only the title matched.
    function scoreGroup(g, q, qLower) {
      var titleLower = (g.title || '').toLowerCase();
      var titlePrefix = qLower && titleLower.indexOf(qLower) === 0;
      var titleHit    = qLower && !titlePrefix && titleLower.indexOf(qLower) > -1;
      var skuPrefix = false, skuHit = false;
      for (var i = 0; i < g.skus.length; i++) {
        var s = g.skus[i].sku;
        if (s.indexOf(q) === 0) { skuPrefix = true; break; }
        if (s.indexOf(q) > -1)  { skuHit = true; }
      }
      if (skuPrefix)   return 4;
      if (titlePrefix) return 3;
      if (skuHit)      return 2;
      if (titleHit)    return 1;
      return 0;
    }

    function filterMatches(q) {
      q = (q || '').trim().toUpperCase();
      if (q.length < 2) return [];
      // Exact SKU match? Hide list — user has it.
      if (skuMap[q]) return [];
      var qLower = q.toLowerCase();
      var scored = [];
      for (var i = 0; i < productGroups.length; i++) {
        var g = productGroups[i];
        var s = scoreGroup(g, q, qLower);
        if (s > 0) scored.push({ g: g, s: s });
      }
      scored.sort(function (a, b) { return b.s - a.s; });
      // Cap at 4 product groups so the dropdown stays compact.
      return scored.slice(0, 4).map(function (x) { return x.g; });
    }

    function closeAC() {
      ac.hidden = true;
      ac.innerHTML = '';
      acItems = [];
      acIndex = -1;
      skuInput.setAttribute('aria-expanded', 'false');
      skuInput.removeAttribute('aria-activedescendant');
    }

    function highlightAC(i) {
      if (!acItems.length) return;
      acIndex = ((i % acItems.length) + acItems.length) % acItems.length;
      acItems.forEach(function (li, idx) {
        var sel = idx === acIndex;
        li.setAttribute('aria-selected', sel ? 'true' : 'false');
        if (sel) {
          skuInput.setAttribute('aria-activedescendant', li.id);
          if (li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    function inventoryHTML(m) {
      if (m.inventory === null) {
        return m.available ? '' : '<span class="qo-sku__ac-inv qo-sku__ac-inv--oos">Out of stock</span>';
      }
      if (m.inventory <= 0) return '<span class="qo-sku__ac-inv qo-sku__ac-inv--oos">Out of stock</span>';
      if (m.inventory < 10) return '<span class="qo-sku__ac-inv qo-sku__ac-inv--low">' + m.inventory + ' left</span>';
      return '<span class="qo-sku__ac-inv">' + m.inventory + ' in stock</span>';
    }
    function priceMetaHTML(m) {
      var parts = [];
      if (m.price) parts.push('<b class="qo-sku__ac-price">' + escHTML(m.price) + '</b>');
      if (m.msrp)  parts.push('<s class="qo-sku__ac-msrp">MSRP ' + escHTML(m.msrp) + '</s>');
      return parts.length ? '<span class="qo-sku__ac-meta-line">' + parts.join('') + '</span>' : '';
    }

    function renderAC(groups) {
      if (!groups.length) { closeAC(); return; }
      var html = '';
      var optIdx = 0;
      var skuCap = 6; // per group
      groups.forEach(function (g, gi) {
        var multi = g.skus.length > 1;
        if (multi) {
          var firstSku = g.skus[0] && g.skus[0].sku || '';
          html += '<li role="presentation" class="qo-sku__ac-product"'
               +    (gi > 0 ? ' data-qo-ac-divider="1"' : '')
               +    ' data-qo-ac-first-sku="' + escHTML(firstSku) + '">'
               +    '<span class="qo-sku__ac-product-title">' + escHTML(g.title) + '</span>'
               +    '<span class="qo-sku__ac-product-meta">' + g.skus.length + ' SKUs</span>'
               +  '</li>';
        }
        g.skus.slice(0, skuCap).forEach(function (m, si) {
          var label;
          if (multi) {
            label = m.variant || '';
          } else {
            label = m.variant ? (m.title + ' — ' + m.variant) : m.title;
          }
          var optId = 'qo-ac-' + (optIdx++) + '-' + (root.id || 'x');
          var rowCls = 'qo-sku__ac-row' + (multi ? ' qo-sku__ac-row--child' : '');
          var divider = !multi && si === 0 && gi > 0 ? ' data-qo-ac-divider="1"' : '';
          html += '<li role="option" id="' + optId + '" class="' + rowCls + '" data-qo-ac-sku="' + escHTML(m.sku) + '"' + divider + ' aria-selected="false">'
               +    '<span class="qo-sku__ac-sku">' + escHTML(m.sku) + '</span>'
               +    '<span class="qo-sku__ac-stack">'
               +      '<span class="qo-sku__ac-row-top">'
               +        (label ? '<span class="qo-sku__ac-title">' + escHTML(label) + '</span>' : '<span class="qo-sku__ac-title"></span>')
               +        inventoryHTML(m)
               +      '</span>'
               +      priceMetaHTML(m)
               +    '</span>'
               +  '</li>';
        });
      });
      ac.innerHTML = html;
      acItems = Array.prototype.slice.call(ac.querySelectorAll('li[role="option"]'));
      acIndex = -1;
      ac.hidden = false;
      skuInput.setAttribute('aria-expanded', 'true');

      // mousedown fires before the input's blur, so focus is preserved.
      acItems.forEach(function (li) {
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          skuInput.value = li.dataset.qoAcSku || '';
          closeAC();
          skuInput.focus();
        });
      });
      // Product header click → fill with the group's first SKU (and select,
      // so the user can keep typing to refine).
      ac.querySelectorAll('.qo-sku__ac-product').forEach(function (hdr) {
        hdr.addEventListener('mousedown', function (e) {
          e.preventDefault();
          skuInput.value = hdr.dataset.qoAcFirstSku || '';
          closeAC();
          skuInput.focus();
          skuInput.select();
        });
      });
    }

    skuInput.addEventListener('input', function () {
      renderAC(filterMatches(skuInput.value));
    });
    skuInput.addEventListener('focus', function () {
      var v = skuInput.value;
      if (v && v.trim().length >= 2) renderAC(filterMatches(v));
    });
    skuInput.addEventListener('keydown', function (e) {
      if (ac.hidden || !acItems.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlightAC(acIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlightAC(acIndex - 1); }
      else if (e.key === 'Enter' && acIndex > -1) {
        e.preventDefault();
        skuInput.value = acItems[acIndex].dataset.qoAcSku || '';
        closeAC();
      }
      else if (e.key === 'Escape') { closeAC(); }
    });
    document.addEventListener('mousedown', function (e) {
      if (!root.contains(e.target)) closeAC();
    });

    root.querySelectorAll('[data-qo-chip]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        skuInput.value = chip.dataset.qoChipSku || '';
        closeAC();
        skuInput.focus();
        skuInput.select();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sku = (skuInput.value || '').trim().toUpperCase();
      var qty = clampQty(parseInt(qtyInput.value, 10) || 1);
      if (!sku) { showToast('Enter a SKU first.', 'error'); skuInput.focus(); return; }

      var entry = skuMap[sku];
      if (entry) { addToCart(entry.id, qty, entry.title); return; }

      // Fallback: live storefront lookup. Requires SKU search to be enabled
      // in the Search & Discovery app; otherwise this returns no matches and
      // the user sees "SKU not found".
      setBusy(true);
      fetch('/search/suggest.json?q=' + encodeURIComponent(sku)
            + '&resources[type]=product'
            + '&resources[options][unavailable_products]=last'
            + '&resources[limit]=4')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var hits = ((data || {}).resources || {}).results || {};
          var products = hits.products || [];
          if (!products.length) throw new Error('not-found');
          // Predictive search returns product handle, not variant ID.
          // Fetch the product JSON and find the variant whose SKU matches.
          var tries = products.slice(0, 3).map(function (p) {
            return fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); });
          });
          return Promise.all(tries).then(function (prods) {
            for (var i = 0; i < prods.length; i++) {
              var match = (prods[i].variants || []).find(function (v) {
                return v.sku && v.sku.trim().toUpperCase() === sku;
              });
              if (match) return { id: match.id, title: prods[i].title };
            }
            throw new Error('not-found');
          });
        })
        .then(function (found) { addToCart(found.id, qty, found.title); })
        .catch(function () {
          setBusy(false);
          showToast('SKU "' + sku + '" not found.', 'error');
        });
    });

    function addToCart(variantId, qty, title) {
      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      })
        .then(function (r) {
          return r.json().then(function (b) { return { ok: r.ok, body: b }; });
        })
        .then(function (res) {
          setBusy(false);
          if (!res.ok) {
            showToast((res.body && res.body.description) || 'Could not add to order.', 'error');
            return;
          }
          showToast('Added ' + qty + ' × ' + (title || 'item') + ' to order.', 'success');
          skuInput.value = '';
          qtyInput.value = qtyInput.min || 1;
          closeAC();
          // Notify the host theme to refresh its cart UI. Different themes
          // listen for different event names; dispatch all the common ones.
          var detail = { item: res.body, source: 'qo-sku' };
          ['cart:refresh', 'cart:updated', 'cart:added', 'cart-updated'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: detail }));
          });
        })
        .catch(function () {
          setBusy(false);
          showToast('Network error. Try again.', 'error');
        });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-qo-section]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (!root || root.dataset.poBound === '1') return;
    root.dataset.poBound = '1';

    var btn     = root.querySelector('[data-po-claim]');
    var label   = root.querySelector('[data-po-label]');
    var spinner = root.querySelector('[data-po-spinner]');
    var msgEl   = root.querySelector('[data-po-msg]');
    if (!btn) return;

    function showMsg(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.classList.toggle('po__msg--error', !!isError);
      msgEl.hidden = false;
    }
    function setBusy(busy) {
      btn.dataset.busy = busy ? '1' : '0';
      btn.disabled = busy;
      if (spinner) spinner.hidden = !busy;
      if (label) label.style.opacity = busy ? '.7' : '';
    }

    function refreshCart() {
      // Theme-agnostic: dispatch the common cart-refresh event family.
      ['cart:refresh', 'cart:updated', 'cart:added', 'cart-updated'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: {} }));
      });
      // Rebuy Smart Cart (this theme's drawer): open + refresh if the API is present.
      try {
        if (window.Rebuy && window.Rebuy.SmartCart) {
          if (typeof window.Rebuy.SmartCart.update === 'function') window.Rebuy.SmartCart.update();
          if (typeof window.Rebuy.SmartCart.show === 'function') window.Rebuy.SmartCart.show();
        }
      } catch (e) {}
    }

    function gatherGifts() {
      var out = [];
      root.querySelectorAll('[data-po-gift-variant]').forEach(function (el) {
        var gid = el.getAttribute('data-po-gift-variant');
        if (gid) out.push(parseInt(gid, 10));
      });
      return out;
    }

    // Low-level add-to-cart. Takes raw line descriptors ({id, selling_plan?}),
    // posts them in one request, applies the discount cookie, refreshes the cart.
    // `ctx` lets the headline CTA and the wizard drive their own busy/message UI.
    function postItems(rawItems, ctx) {
      var items = [];
      rawItems.forEach(function (it) {
        if (!it || !it.id) return;
        var line = { id: parseInt(it.id, 10), quantity: 1 };
        if (it.selling_plan) line.selling_plan = parseInt(it.selling_plan, 10);
        items.push(line);
      });
      if (!items.length) { ctx.onError('This offer is not configured yet.'); return; }

      var code = (root.getAttribute('data-discount') || '').trim();
      ctx.setBusy(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          // Apply discount code without navigating: the /discount/<code> route
          // sets the discount cookie on this same-origin response, carrying to checkout.
          // Automatic discounts need no code — just skip this.
          if (code) {
            return fetch('/discount/' + encodeURIComponent(code), {
              method: 'GET',
              credentials: 'same-origin',
              redirect: 'follow'
            }).catch(function () { /* non-fatal: items are already in the cart */ });
          }
        })
        .then(function () {
          ctx.onSuccess();
          refreshCart();
        })
        .catch(function (err) {
          ctx.onError(err && err.message ? err.message : 'Something went wrong. Please try again.');
        })
        .finally(function () {
          ctx.setBusy(false);
        });
    }

    var mainCtx = {
      setBusy: setBusy,
      onSuccess: function () { showMsg(root.getAttribute('data-success') || 'Added to your cart!', false); },
      onError: function (m) { showMsg(m, true); }
    };

    // Variant wizard (present when the headline OR any gift has >1 variant).
    var openModal = setupModal(root, postItems, showMsg);

    btn.addEventListener('click', function () {
      if (btn.dataset.busy === '1' || btn.disabled) return;
      if (msgEl) msgEl.hidden = true;
      if (openModal) { openModal(); return; }
      // No picker needed: add the headline variant + gift defaults straight away.
      var raw = [];
      var v = root.getAttribute('data-vault-variant');
      if (v) raw.push({ id: v, selling_plan: root.getAttribute('data-vault-selling-plan') });
      gatherGifts().forEach(function (gid) { raw.push({ id: gid }); });
      postItems(raw, mainCtx);
    });
  }

  // Multi-step variant wizard: one step per product (headline + each gift) that
  // has multiple variants. Returns an `open()` function, or null when there is
  // no wizard to drive (no [data-po-modal], or its steps have no variant data).
  function setupModal(root, postItems, showMainMsg) {
    var modal = root.querySelector('[data-po-modal]');
    if (!modal) return null;
    function slice(nl) { return Array.prototype.slice.call(nl); }

    var stepEls = slice(modal.querySelectorAll('[data-po-step]'));
    if (!stepEls.length) return null;

    var panel    = modal.querySelector('.po-vp__panel');
    var confirmBtn = modal.querySelector('[data-po-confirm]');
    var confirmLbl = modal.querySelector('[data-po-confirm-label]');
    var backBtn  = modal.querySelector('[data-po-back]');
    var cSpinner = modal.querySelector('[data-po-modal-spinner]');
    var cMsg     = modal.querySelector('[data-po-modal-msg]');
    var unavail  = modal.querySelector('[data-po-unavailable]');
    var dots     = slice(modal.querySelectorAll('[data-po-dot]'));
    if (!confirmBtn || !confirmLbl) return null;

    var claimText = confirmLbl.textContent;
    var nextText  = confirmBtn.getAttribute('data-po-next-label') || 'Next';

    // Fixed items (products with no choice — always added as-is).
    var fixed = [];
    var fixedEl = modal.querySelector('[data-po-fixed]');
    if (fixedEl) { try { fixed = JSON.parse(fixedEl.textContent) || []; } catch (e) { fixed = []; } }

    // Live mirrors on the headline card (driven by the vault step only).
    var cardNow = root.querySelector('[data-po-vault-now]');
    var cardWas = root.querySelector('[data-po-vault-was]');
    var cardPay = root.querySelector('[data-po-vault-pay]');

    var steps = stepEls.map(function (el) {
      var variants = [];
      var vEl = el.querySelector('[data-po-step-variants]');
      if (vEl) { try { variants = JSON.parse(vEl.textContent) || []; } catch (e) { variants = []; } }
      return {
        el: el,
        kind: el.getAttribute('data-po-step-kind'),
        variants: variants,
        groups: slice(el.querySelectorAll('[data-po-opt]')),
        nowEl: el.querySelector('[data-po-step-now]'),
        wasEl: el.querySelector('[data-po-step-was]'),
        imgEl: el.querySelector('[data-po-step-img]'),
        selected: [],
        current: null
      };
    });
    // Defensive: if any step is missing variant data, fall back to the direct add.
    if (steps.some(function (s) { return !s.variants.length; })) return null;

    var idx = 0;
    var lastFocus = null;

    function modalMsg(text, isError) {
      if (!cMsg) return;
      cMsg.textContent = text || '';
      cMsg.classList.toggle('po-vp__msg--error', !!isError);
      cMsg.hidden = !text;
    }

    function findVariant(step, opts) {
      for (var i = 0; i < step.variants.length; i++) {
        var vo = step.variants[i].options || [], ok = true;
        for (var j = 0; j < opts.length; j++) { if (vo[j] !== opts[j]) { ok = false; break; } }
        if (ok) return step.variants[i];
      }
      return null;
    }

    // Per-step pill setup: hide values carried by no variant (e.g. a gated
    // One-time on the vault step), dim sold-out values, and wire clicks.
    steps.forEach(function (step) {
      step.groups.forEach(function (g) {
        var oi = parseInt(g.getAttribute('data-po-opt'), 10);
        var visible = 0;
        slice(g.querySelectorAll('[data-po-opt-value]')).forEach(function (p) {
          var val = p.getAttribute('data-po-opt-value');
          var exists = step.variants.some(function (v) { return (v.options || [])[oi] === val; });
          if (!exists) { p.hidden = true; return; }
          visible++;
          var any = step.variants.some(function (v) { return v.available && (v.options || [])[oi] === val; });
          if (!any) p.setAttribute('data-po-soldout', '1');
          p.addEventListener('click', function () {
            if (p.hidden || p.getAttribute('data-po-soldout') === '1') return;
            step.selected[oi] = val;
            renderStep(step);
            syncNav();
          });
        });
        if (!visible) g.hidden = true;
      });
    });

    function defaultSelect(step) {
      var def = null;
      for (var i = 0; i < step.variants.length; i++) { if (step.variants[i].available) { def = step.variants[i]; break; } }
      if (!def) def = step.variants[0];
      step.selected = step.groups.map(function (g) {
        var oi = parseInt(g.getAttribute('data-po-opt'), 10);
        return def ? (def.options || [])[oi] : null;
      });
    }

    function renderStep(step) {
      var fully = step.selected.length === step.groups.length && step.selected.indexOf(null) === -1;
      step.current = fully ? findVariant(step, step.selected) : null;
      step.groups.forEach(function (g) {
        var oi = parseInt(g.getAttribute('data-po-opt'), 10);
        slice(g.querySelectorAll('[data-po-opt-value]')).forEach(function (p) {
          p.setAttribute('aria-pressed', p.getAttribute('data-po-opt-value') === step.selected[oi] ? 'true' : 'false');
        });
      });
      var cur = step.current;
      if (step.imgEl && cur && cur.image) step.imgEl.src = cur.image;
      if (step.nowEl) step.nowEl.textContent = cur && cur.price_money ? cur.price_money : '';
      if (step.wasEl) { var w = cur && cur.compare_money; step.wasEl.textContent = w || ''; step.wasEl.hidden = !w; }
      if (step.kind === 'vault' && cur) {
        if (cardNow && cur.price_money) cardNow.textContent = cur.price_money;
        if (cardWas) { cardWas.textContent = cur.compare_money || ''; cardWas.hidden = !cur.compare_money; }
        if (cardPay && cur.price_money) cardPay.textContent = cur.price_money;
      }
    }

    function syncNav() {
      var step = steps[idx];
      var ready = !!(step.current && step.current.available);
      var last = idx === steps.length - 1;
      confirmBtn.disabled = !ready;
      confirmBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      confirmLbl.textContent = last ? claimText : nextText;
      if (backBtn) backBtn.hidden = idx === 0;
      if (unavail) {
        var fully = step.selected.length === step.groups.length && step.selected.indexOf(null) === -1;
        unavail.hidden = !(fully && (!step.current || !step.current.available));
      }
      dots.forEach(function (d, i) {
        d.classList.toggle('po-vp__dot--on', i <= idx);
        d.classList.toggle('po-vp__dot--cur', i === idx);
      });
      modalMsg('');
    }

    function showStep(i) {
      idx = i;
      steps.forEach(function (s, n) { s.el.hidden = n !== i; });
      syncNav();
      if (panel) panel.scrollTop = 0;
    }

    function setBusy(busy) {
      confirmBtn.dataset.busy = busy ? '1' : '0';
      var step = steps[idx];
      confirmBtn.disabled = busy || !(step.current && step.current.available);
      if (cSpinner) cSpinner.hidden = !busy;
      if (backBtn) backBtn.disabled = busy;
    }

    function claim() {
      var chosen = steps.map(function (s) { return { id: s.current.id, selling_plan: s.current.selling_plan }; });
      postItems(fixed.concat(chosen), {
        setBusy: setBusy,
        onSuccess: function () { showMainMsg(root.getAttribute('data-success') || 'Added to your cart!', false); close(); },
        onError: function (m) { modalMsg(m, true); }
      });
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    function open() {
      lastFocus = document.activeElement;
      steps.forEach(function (s) { defaultSelect(s); renderStep(s); });
      showStep(0);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
      (panel || confirmBtn).focus();
    }
    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKey);
      setBusy(false);
      modalMsg('');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    confirmBtn.addEventListener('click', function () {
      if (confirmBtn.dataset.busy === '1') return;
      var step = steps[idx];
      if (!(step.current && step.current.available)) return;
      if (idx < steps.length - 1) { showStep(idx + 1); }
      else { claim(); }
    });
    if (backBtn) backBtn.addEventListener('click', function () { if (idx > 0 && confirmBtn.dataset.busy !== '1') showStep(idx - 1); });
    slice(modal.querySelectorAll('[data-po-close]')).forEach(function (c) { c.addEventListener('click', close); });

    return open;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-po-root]');
    roots.forEach(function (r) { bind(r); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
